import { render, staticRenderFns } from "./certificateupload.vue?vue&type=template&id=09fc916f&scoped=true"
import script from "./certificateupload.vue?vue&type=script&lang=js"
export * from "./certificateupload.vue?vue&type=script&lang=js"
import style0 from "./certificateupload.vue?vue&type=style&index=0&id=09fc916f&prod&scoped=true&lang=css"
import style1 from "./certificateupload.vue?vue&type=style&index=1&id=09fc916f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fc916f",
  null
  
)

export default component.exports